// COMPONENTS
// Funcions preparades per importar

const loadingComponent = `
<span class="Polaris-Spinner Polaris-Spinner--sizeLarge">
	<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
		<path d="M15.542 1.487A21.507 21.507 0 00.5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 00-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 10-.9-2.863z"></path>
	</svg>
</span>
<span role="status">
	<span class="Polaris-Text--root Polaris-Text--visuallyHidden">Spinner example</span>
</span>`;

const smallLoadingComponent = `
<span class="Polaris-Spinner Polaris-Spinner--sizeSmall">
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z">
    </path>
  </svg>
</span>
<span role="status">
  <span class="Polaris-Text--root Polaris-Text--visuallyHidden">Small spinner example</span>
</span>`;

const skelletonComponent = `
<div class="Polaris-BlockStack" style="--pc-block-stack-inline-align:center;--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-400)">
  <div class="Polaris-Box" style="--pc-box-max-width:var(--pc-skeleton-page-max-width);--pc-box-padding-block-start-xs:var(--p-space-0);--pc-box-padding-block-end-xs:var(--p-space-0);--pc-box-padding-inline-start-sm:var(--p-space-600);--pc-box-padding-inline-end-sm:var(--p-space-600);--pc-box-width:100%" role="status" aria-label="Page loading">
    <div class="Polaris-BlockStack" style="--pc-block-stack-order:column">
      <div class="Polaris-Box" style="--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-start-md:var(--p-space-500);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-block-end-md:var(--p-space-500);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-start-sm:var(--p-space-0);--pc-box-padding-inline-end-xs:var(--p-space-400);--pc-box-padding-inline-end-sm:var(--p-space-0);--pc-box-width:100%">
        <div class="Polaris-InlineStack" style="--pc-inline-stack-align:space-between;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row">
          <div class="Polaris-InlineStack" style="--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row">
            <div class="Polaris-Box" style="--pc-box-padding-block-start-xs:var(--p-space-100);--pc-box-padding-block-end-xs:var(--p-space-100)">
              <div class="Polaris-SkeletonPage__SkeletonTitle">
                <div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-fill-tertiary);--pc-box-border-radius:var(--p-border-radius-100);--pc-box-min-height:28px;--pc-box-min-width:120px">                
                </div>
              </div>
            </div>
          </div>
          <div class="Polaris-Box" id="SkeletonPage-PrimaryAction" style="--pc-box-background:var(--p-color-bg-fill-tertiary);--pc-box-border-radius:var(--p-border-radius-100);--pc-box-min-height:2.25rem;--pc-box-min-width:6.25rem">          
          </div>
        </div>
      </div>
      <div class="Polaris-Box" style="--pc-box-padding-block-end-xs:var(--p-space-200);--pc-box-width:100%">
        <div class="Polaris-Layout">
          <div class="Polaris-Layout__Section">
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                </div>
              </div>
            </div>
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="Polaris-Layout__Section Polaris-Layout__Section--oneThird">
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                </div>
              </div>
            </div>
            <div class="Polaris-LegacyCard Polaris-LegacyCard--subdued">
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding">
                <div class="Polaris-TextContainer">
                  <div class="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeSmall">
                  </div>
                  <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                    <div class="Polaris-SkeletonBodyText">
                    </div>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__LastSectionPadding">
                <div class="Polaris-SkeletonBodyText__SkeletonBodyTextContainer">
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                  <div class="Polaris-SkeletonBodyText">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`;

const backButtonComponent = function (previousPage = 'dashboard') {	
	return `
<button class="Polaris-FullscreenBar__BackAction" page-link="`+previousPage+`">
  <span class="Polaris-Icon">
	<svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
	  <path d="M9.75 3c-1.243 0-2.25 1.007-2.25 2.25 0 .414.336.75.75.75s.75-.336.75-.75.336-.75.75-.75h3.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.414 0-.75-.336-.75-.75s-.336-.75-.75-.75-.75.336-.75.75c0 1.243 1.007 2.25 2.25 2.25h3.5c1.519 0 2.75-1.231 2.75-2.75v-8.5c0-1.519-1.231-2.75-2.75-2.75h-3.5Z">
	  </path>
	  <path d="M12.25 10.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-5.69l.97-.97c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-2.25 2.25c-.141.14-.22.331-.22.53s.079.39.22.53l2.25 2.25c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-.97-.97h5.69Z">
	  </path>
	</svg>
  </span>
  <span class="Polaris-Text--root Polaris-Text--bodyLg">Back</span>
</button>`;
}

const fullScreenBarComponent = function (backButton = false) {
	var copilotHeader = `
<div style="display:flex;flex-grow:1;justify-content:space-between;align-items:center;padding-left:1rem;padding-right:1rem">
  <span class="Polaris-Icon">
    <img class="Polaris-Icon__Img" src="./frontend/assets/images/logo.png" alt="" aria-hidden="true">
  </span>
  <div style="margin-left:1rem;flex-grow:1">		  
	<p class="Polaris-Text--root Polaris-Text--headingLg">Acumen Shift <span class="Polaris-Text--bodyXs">v1.0.1</span></p>
  </div>      
</div>`;
	if(backButton) {
		copilotHeader = backButtonComponent() + copilotHeader;
	}
	return `<div class="Polaris-FullscreenBar">`+copilotHeader+`</div>`;
}

const indicatorComponent = function (indicator) {
    var no_data = false;
    if(indicator.value == "-" || indicator.value <= 0) {
        no_data = true;
    }
	var indicator_html = `
<div class="Polaris-Grid-Cell 
				  Polaris-Grid-Cell--cell_3ColumnXs 
				  Polaris-Grid-Cell--cell_2ColumnSm 
				  Polaris-Grid-Cell--cell_2ColumnMd 
				  Polaris-Grid-Cell--cell_3ColumnLg 
				  Polaris-Grid-Cell--cell_3ColumnXl">
	<div class="Polaris-LegacyCard">
	  <div class="Polaris-LegacyCard__Header Polaris-LegacyCard__FirstSectionPadding">
		<h2 class="Polaris-Text--root Polaris-Text--headingSm">`+indicator.title+`</h2>
	  </div>
	  <div class="Polaris-LegacyCard__Section">
		<p class="Polaris-Text--root Polaris-Text--center Polaris-Text--headingLg">`;
    if(no_data) {
        indicator_html += `<span class="Polaris-Text--bodySm">Not enough data</span>`;
    } else {
        indicator_html += `<span class="Polaris-Text--heading3xl">`+indicator.value+`</span>`+indicator.units;
    }
    indicator_html += `
		</p>
	  </div>
	  <div class="Polaris-LegacyCard__Section Polaris-LegacyCard__LastSectionPadding">
		<p class="Polaris-Text--root Polaris-Text--bodyXs">`+indicator.desc+`</p>
	  </div>
</div>
</div>
	`;
	return indicator_html;
}

const footerComponent = `
<br><br/>
<hr class="Polaris-Divider" style="border-block-start:var(--p-border-width-025) solid var(--p-color-border)">
<div class="Polaris-InlineGrid" style="--pc-inline-grid-grid-template-columns-xs:1fr auto">
<div class="Polaris-FooterHelp" style="--pc-footer-help-align:start">
    <p class="Polaris-Text--root Polaris-Text--bodyXs">
    <a class="Polaris-Link" data-polaris-unstyled="true" page-link="legal">Privacy Policy</a>
  </p>
 </div>
<div class="Polaris-FooterHelp" style="--pc-footer-help-align:end">
  <p class="Polaris-Text--root Polaris-Text--bodyXs">© Acumen Shift 1.0 2024<!-- --></p>
</div>
`;

const dashboardFilterComponent = `
<div class="Polaris-Labelled--hidden">
  <div class="Polaris-Labelled__LabelWrapper">
    <div class="Polaris-Label">
      <label id=":Rq6:Label" for=":Rq6:" class="Polaris-Label__Text">
        <span class="Polaris-Text--root Polaris-Text--bodyMd">Sort by</span>
      </label>
    </div>
  </div>
  <div class="Polaris-Select">
    <select id="select-input" class="Polaris-Select__Input" aria-invalid="false">
      <option value="1">Today</option>
      <option value="2">Yesterday</option>
      <option value="3">Last 7 days</option>
      <option value="4">Last 30 days</option>
    </select>
    <div class="Polaris-Select__Content" aria-hidden="true">
      <div class="Polaris-Box" style="--pc-box-padding-inline-end-xs:var(--p-space-100)">
        <span class="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--block Polaris-Text--subdued Polaris-Text--truncate">Sort by</span>
      </div>
      <span id="selected-option" class="Polaris-Select__SelectedOption">Today</span>
      <span class="Polaris-Select__Icon">
        <span class="Polaris-Icon">
          <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
            <path d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z">
            </path>
            <path d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z">
            </path>
          </svg>
        </span>
      </span>
    </div>
    <div class="Polaris-Select__Backdrop">
    </div>
  </div>
</div>
`;

const dismissibleBannerComponent = `
<div class="Polaris-Banner Polaris-Banner--withinPage" tabindex="0" role="status" aria-live="polite" id="initialBanner" style="margin-bottom:30px;">
  <div class="Polaris-Box" style="--pc-box-border-radius:var(--p-border-radius-300);--pc-box-padding-block-start-xs:var(--p-space-300);--pc-box-padding-block-end-xs:var(--p-space-300);--pc-box-padding-inline-start-xs:var(--p-space-300);--pc-box-padding-inline-end-xs:var(--p-space-300);--pc-box-width:100%">
    <div class="Polaris-InlineStack" style="--pc-inline-stack-align:space-between;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-flex-direction-xs:row">
      <div class="Polaris-Box" style="--pc-box-width:100%">
        <div class="Polaris-InlineStack" style="--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row">
          <div>
            <div class="Polaris-Box" style="--pc-box-background:var(--p-color-bg-fill-info);--pc-box-border-radius:var(--p-border-radius-200);--pc-box-padding-block-start-xs:var(--p-space-100);--pc-box-padding-block-end-xs:var(--p-space-100);--pc-box-padding-inline-start-xs:var(--p-space-100);--pc-box-padding-inline-end-xs:var(--p-space-100)">
              <span class="Polaris-Banner--textInfoOnBgFill">
                <span class="Polaris-Icon">
                  <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                    <path d="M10 14a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-.75.75Z">
                    </path>
                    <path d="M9 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z">
                    </path>
                    <path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z">
                    </path>
                  </svg>
                </span>
              </span>
            </div>
          </div>
          <div class="Polaris-Box" style="--pc-box-width:100%">
            <div class="Polaris-BlockStack" style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)">
              <div>
                <span class="Polaris-Text--root Polaris-Text--bodyMd">
                  <p><b>Please note:</b> In the first few days, you may not see relevant data yet.  We recommend waiting at least 7 days for our systems to display accurate information. Please contact us if you have any questions at <button type="button" class="Polaris-Link Polaris-Link--monochrome" external-link="https://acumenshift.com/contact-en/">https://acumenshift.com/contact-en</button>.
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Polaris-Banner__DismissIcon">
      <button class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly" aria-label="Dismiss notification" type="button" dismiss="initialBanner">
        <span class="Polaris-Button__Icon">
          <span class="Polaris-Banner__icon--secondary">
            <span class="Polaris-Icon">
              <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                <path d="M13.97 15.03a.75.75 0 1 0 1.06-1.06l-3.97-3.97 3.97-3.97a.75.75 0 0 0-1.06-1.06l-3.97 3.97-3.97-3.97a.75.75 0 0 0-1.06 1.06l3.97 3.97-3.97 3.97a.75.75 0 1 0 1.06 1.06l3.97-3.97 3.97 3.97Z">
                </path>
              </svg>
            </span>
          </span>
        </span>
      </button>
    </div>
  </div>
</div>
</div>
`;

const dashboardBannerComponent = `
<div class="Polaris-LegacyCard" style="flex: 1;margin-top:5%;">
    <div class="Polaris-MediaCard">
        <div class="Polaris-MediaCard__MediaContainer">
            <div class="Polaris-VideoThumbnail__ThumbnailContainer">
                <div class="Polaris-VideoThumbnail__Thumbnail" style="background-color:#eef5fe;background-size: auto 100%;background-repeat: no-repeat;background-position: center;padding-bottom:10%;background-image:url(./frontend/assets/images/1970a14d-edce-4545-acf2-f45bd63bd1ed.png)">
                </div>
            </div>
        </div>
        <div class="Polaris-MediaCard__InfoContainer">
            <div class="Polaris-Box" style="--pc-box-padding-block-start-xs:var(--p-space-500);--pc-box-padding-block-end-xs:var(--p-space-500);--pc-box-padding-inline-start-xs:var(--p-space-500);--pc-box-padding-inline-end-xs:var(--p-space-500)">
                <div class="Polaris-BlockStack" style="--pc-block-stack-order:column;--pc-block-stack-gap-xs:var(--p-space-200)">
                    <div class="Polaris-InlineStack" style="--pc-inline-stack-align:space-between;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row">
                        <div>
                            <h2 class="Polaris-Text--root Polaris-Text--headingSm">
                                Track for free your store's key performances and get alerts in real-time, with our mobile app!
                            </h2>
                        </div>
                    </div>
                    <p class="Polaris-Text--root Polaris-Text--bodyMd">
                        Get instant alerts on unexpected performance changes and receive regular reports
                        to optimize your store.
                    </p>
                    <p class="Polaris-Text--root Polaris-Text--bodyMd">
                        Free, available on iOS & Android and easy to use. Quick 2-step
                        onboarding: install the Shopify extension, download our mobile app, and start improving
                        your store’s performance today!
                    </p>
                    <div class="Polaris-MediaCard__ActionContainer">
                        <div class="Polaris-ButtonGroup" style="justify-content: flex-end">
                            <div class="Polaris-ButtonGroup__Item">
                                <button class="Polaris-Link Polaris-Link--monochrome" external-link="https://play.google.com/store/apps/details?id=com.acumenshift.app"><img width="100%;" src="./frontend/assets/images/google_play_badge.png"></button>
                            </div>
                            <div class="Polaris-ButtonGroup__Item">
                                <button class="Polaris-Link Polaris-Link--monochrome" external-link="https://apps.apple.com/es/app/acumen-shift/id6744528204"><img width="100%;" src="./frontend/assets/images/appstore_badge.svg"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;

export { 
	loadingComponent,
	smallLoadingComponent,
	skelletonComponent,
	fullScreenBarComponent,
	indicatorComponent,
	footerComponent,
    dashboardFilterComponent,
    dismissibleBannerComponent,
    dashboardBannerComponent
}
